<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:content="page.content"
			:roomtypeid="page.bookingID"
			:color="page.color"
			:heading-image="page.headingImages && page.headingImages[0]"
		/>

		<section class="rooms-items">
			<div class="row">
				<div v-if="events && events.length" class="columns column12 align-left">
					<h3>{{ $t('upcomingEvents') }}</h3>
				</div>
				<div v-for="event in events" :key="event.pageID" class="columns column4">
					<nuxt-link :to="localePath(`/${event.filename}`)">
						<picture>
							<source :srcset="event.imageOverviewWebp" type="image/webp" />
							<source :srcset="event.imageOverview" />
							<img :src="event.imageOverview" :alt="event.imageOverviewAlt" loading="lazy" />
						</picture>
					</nuxt-link>
					<h3>{{ event.header }}</h3>
					<div v-parse-links v-html="event.contentOverview" />
					<nuxt-link :to="localePath(`/${event.filename}`)" class="button button-no-fill">
						{{ $t('readMore') }}
					</nuxt-link>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();

const { data: events } = await useWebsiteFetch('events', {
	query: { language: locale.value },
	key: `${locale.value}/events`,
});
</script>

<style lang="scss" scoped>
.rooms-items {
	margin-bottom: 5px;
	padding: 50px 0;

	.row {
		display: flex;
		flex-flow: row wrap;
		align-items: stretch;
		justify-content: center;
	}

	h3 {
		margin: 0;
	}

	.column12 {
		h3 {
			margin: 0 0 20px;
		}
	}

	.column4 {
		display: flex;
		flex-direction: column;
		margin-bottom: 50px;

		.button {
			margin-top: auto;
			align-self: flex-start;
		}
	}

	img {
		margin: 20px 0;
	}
}
</style>
